/*eslint-disable */
const $ = window.jQuery = require('jquery');

import 'vue-datetime/dist/vue-datetime.css'

import allCountries from '@/services/phoneCodeList.json';
import countries from '@/services/country.json';
import {mapGetters} from 'vuex';
import toast from '@/services/toast';

// You need a specific loader for CSS files


export default {
  name: 'update-candidate-form',
  components: {
  },
  props: [],
  data () {
    return {
      submitted:false,
      fullName:'',
      email:'',
      phone: {
        number: '',
        isValid: false,
        countryIso: 'in',
        countryCode:'91'
      },
      allCountriesList:[],
      countryList:[],
      resume:null,
      resumeName:'',
      otherDocs:null,
      otherDocsName:'',
      description:'',
      minDatetime:new Date().toISOString(),
      candidateInfo:null
    }
  },
  computed: {
  },
  mounted () {
    this.$store.dispatch('getInViewerCandidateInfoByIdAction', {id: this.$route.params.candidateId}).then((res) => {
      this.candidateInfo = res.data.data.results
      if(this.candidateInfo){
        this.fullName = this.candidateInfo.name
        this.email = this.candidateInfo.email
        this.description = this.candidateInfo.description
        this.resumeName = this.candidateInfo.resume_name
        this.otherDocsName = this.candidateInfo.other_docs_name || ''   
        this.phone.countryCode = this.candidateInfo.role
        this.fullMobileCountryCode = this.phone.countryCode + ' ' + (this.candidateInfo.phone || '')
        this.phone.number = this.candidateInfo.phone
        this.phone.country = this.candidateInfo.role
      }
    })
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    for (var i = 0; i < allCountries.length; i++) {
      let c = allCountries[i];
      this.allCountriesList.push({
        name: c[0],
        iso2: c[1],
        dialCode: c[2],
        priority: c[3] || 0,
        areaCodes: c[4] || null
      });
    }
    $('.option-list').click(function(e) {
      e.preventDefault();
      $(this).toggleClass('open');
      $(this).find('ul').slideToggle(100);
      if ($(this).hasClass('open')) {
        $('.dropdown-arrow').text('▼');
      } else {
        $('.dropdown-arrow').text('▲');
      }
    });
    $(document).on('click', function(e) {
      var container = $('.option-list');
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('open');
        $('.dropdown-arrow').text('▲');
        container.find('ul').slideUp(100);
      }
    })
  },
  methods: {
    getUserCountry() {
      var self = this;
      fetch('https://ip2c.org/s')
        .then(function(response) {
          return response.text();
        })
        .then(function(text) {
          if (!text || "1" !== text[0])
            throw new Error("unable to fetch the country");
            self.phone.countryIso = (text.substr(2, 2)).toLowerCase();
            self.phone.countryCode = self.allCountriesList.filter(item => item.iso2 == self.phone.countryIso)[0].dialCode;
        })
        .catch(function(error) {
          console.log('Request failed', error)
        });
    },
    chooseCountry(country) { 
      this.phone.countryIso = country.iso2;
      this.phone.countryCode = country.dialCode
    },
    validateBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          var formData = new FormData();
          formData.append('name', this.fullName);
          formData.append('email', this.email);
          if(this.resume){
            formData.append('resume', this.resume);
            formData.append('resume_name', this.resumeName);
          }
          if(this.otherDocs){
            formData.append('other_docs', this.otherDocs);
            formData.append('other_docs_name', this.otherDocsName);
          }
          formData.append('role', '+' + this.phone.countryCode);
          formData.append('phone', this.phone.number);
          formData.append('description', this.description);
          this.$store.dispatch('updateInViewerCandidateInfoByIdAction', {data: {id:this.$route.params.candidateId,data:formData}})
            .then((res) => {  
                this.submitted = false;
                toast.success(res.data.msg || "Request has been successfully submitted");            
                this.$router.push({ name: 'employeeInterviewCandidatesList'})
            }).catch((err) => {
                this.submitted = false;
                toast.error(err.data.user_msg || err.data.msg);
            })
            return;
        }
      });
    },
    clearUploadedResumeMethod(){
      let field = document.getElementById('resumeFile');
      field.value = null
      this.$refs.resumeFile = null
      this.resume = null
      this.resumeName = ''
      this.$validator.reset()
    },
    handleResumeUploadMethod(event) {
      if(event.target.files && event.target.files.length > 0) {
        this.resume = event.target.files[0];
        const files = this.$refs.resumeFile.files[0];
        this.resumeName = files.name
      }else {
        this.resumeName = '';
      }
    },
    clearUploadedOtherDocsMethod(){
      this.otherDocs = null
      this.otherDocsName = ''
      this.$validator.reset();
    },
    handleOtherDocsUploadMethod(event) {
      if(event.target.files && event.target.files.length > 0) {
        this.otherDocs = event.target.files[0];
        const files = this.$refs.otherDocsFile.files[0];
        this.otherDocsName = files.name
      }else {
        this.otherDocsName = '';
      }
    },
  },
  watch:{
  }
}